import { combineReducers } from 'redux'
import { handleActions } from 'redux-actions'

export const message = handleActions({}, null)
export const infoEmail = handleActions({}, null)
export const resendActivationLink = handleActions({}, null)

export default combineReducers({
  message,
  infoEmail,
  resendActivationLink
})
